import { MountainBackdrop } from '../ui/MountainBackdrop';

/** Shared title artwork and its existing Page01 sizing/masking rules. */
export function TitleBackdrop() {
  return (
    <>
      <MountainBackdrop />
      <img
        className="p01-city-banner"
        src="/page01/City_Banner_Reference.png"
        alt="科技赋能，守护更安全的城市与区域 · Safer Cities Through Technology"
      />
    </>
  );
}
